import React, {Component} from "react";
import {reduxForm} from "redux-form";
import {connect} from "react-redux";
import {Trans} from "react-i18next";
import ModalButton from "../../modals/ModalButton";

class ModalInstructionForm extends Component {

    render() {
        return <form>
            <span className="label center">
            <Trans>Instruction - How To Download A Private Media From Any Site</Trans>
            </span>
                <ModalButton id="chrome-modal-component" className="btn chrome">Use Chrome</ModalButton>
                <ModalButton id="mozilla-modal-component" className="btn mozilla right">Use Mozilla</ModalButton>
        </form>
    }
}

ModalInstructionForm = reduxForm({
    form: 'InstructionForm',
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
})(ModalInstructionForm);

export default connect()(ModalInstructionForm);